export function getRedirectData(redirect: string) {
  const url = new URL(redirect, location.origin)
  const query = {}
  url.searchParams.forEach((value, key) => {
    query[key] = value
  })
  return { path: url.pathname, query }
}
